/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAppTask.vue?vue&type=template&id=09d8c50b&scoped=true"
import script from "./popAppTask.vue?vue&type=script&lang=js"
export * from "./popAppTask.vue?vue&type=script&lang=js"
import style0 from "./popAppTask.vue?vue&type=style&index=0&id=09d8c50b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8c50b",
  null
  
)

export default component.exports